// extracted by mini-css-extract-plugin
module.exports = {"body":"body__1qmYS","header":"header__2LZhW","title":"title__2tRt7","description":"description__2Vf_3","bottom-tools":"bottom-tools__2unTe","link-button":"link-button__k8YJ1"};